import { createAppCatalog } from "@iq/models";

export { DEFAULT_ENABLED_APP_IDS } from "@iq/models";

export const APP_CATALOG = createAppCatalog({
  calendar: process.env.REACT_APP_CALENDAR_APP_URL,
  service: process.env.REACT_APP_SERVICE_APP_URL || process.env.REACT_APP_STORE_API_URL,
  store: process.env.REACT_APP_STORE_APP_URL,
  studio: process.env.REACT_APP_STUDIO_APP_URL,
  admin: process.env.REACT_APP_ADMIN_APP_URL
});
